import React, { useState, useEffect, useCallback, useContext } from "react";
import envContext from "./context/EnvContext";
import PlaceHolder from "./DATA/Loader";
import Picker from "./calender/Picker";
import DATA from "./DATA/DATA";
import Fade from "react-fade-in";
import Units from "./calender/Units";
import moment from "moment";
import Times from "./calender/Times";
import Button from "./calender/Button";
import FilterUrl from "./DATA/FilteredURL";
import DisabledDates from "./DATA/DisabledDates";

const DataAdapter = () => {
	const [results, setResults] = useState("loading");
	const [refunds, setRefunds] = useState("loading");
	const [disabled, setDisabled] = useState("loading");
	const [userDD, setUserDD] = useState("loading");
	const [item, setItem] = useState("loading");
	const [error, setError] = useState("none");
	const [dates, setDates] = useState([]);
	const env = useContext(envContext);

	//<<<< variables >>>>
	const type = { payment: "PAYMENT", refund: "REFUND" };
	//for production urls
	// const loc = window.location;
	// const proto = loc.protocol;
	// const host = loc.hostname;

	let id = FilterUrl();

	//console.log(id);

	let Item = {
		id: id
	};

	// console.log(Item);

	// <<< Production Urls >>>

	//production env assignments
	const { host } = env.pro;

	// console.log(proto);
	//console.log(host);

	// const iurl = `${host}/home/getItemInfo/${Item.id}`; // working live
	// const purl = `${host}/home/unavailable_tools_date/${Item.id}/${type.payment}`;
	// const rurl = `${host}/home/unavailable_tools_date/${Item.id}/${type.refund}`;
	// const ddurl = `${host}/home/get_item_settings_react/${Item.id}/USERDD`;

	// console.log(iurl);
	// console.log(purl);
	// console.log(rurl);
	// console.log(ddurl);

	//<<< Dev env assignment >>>
	const { proto } = env.dev;
	const iurl = `${proto}//www.mcclearyrentals.com/home/getItemInfo/${Item.id}`;
	const purl = `${proto}//www.mcclearyrentals.com/home/unavailable_tools_date/${item.id}/${type.payment}`;
	const rurl = `${proto}//www.mcclearyrentals.com/home/unavailable_tools_date/${item.id}/${type.refund}`;
	const ddurl = `${proto}//www.mcclearyrentals.com/home/get_item_settings_react/${item.id}/USERDD`;
	//<<< variable end >>>

	//<<<effect functions >>>

	const fetchItem = useCallback(async () => {
		const data = await fetch(iurl);
		const jsonData = await data.json();
		if (typeof jsonData === "object") {
			setItem(...jsonData);
		} else {
			setError("block");
		}
	}, [iurl]);

	const fetchPayment = useCallback(async () => {
		if (item !== "loading") {
			const data = await fetch(purl);
			const jsonData = await data.json();
			if (typeof jsonData === "object") {
				setResults(jsonData);
			} else {
				setError("block");
			}
		}
	}, [purl]);

	const fetchRefund = useCallback(async () => {
		if (item !== "loading") {
			const data = await fetch(rurl);
			const jsonData = await data.json();
			if (typeof jsonData === "object") {
				setRefunds(jsonData);
			} else {
				setError("block");
			}
		}
	}, [rurl]);

	const fetchUserDD = useCallback(async () => {
		if (item !== "loading") {
			const dd = await fetch(ddurl);
			const jsonData = await dd.json();
			let userdd = jsonData.reduce((memo, value) => {
				memo.push(value.dates.split(","));
				return memo.flat(1 / 0);
			}, []);
			var formattedDD = userdd.reduce((memo, value) => {
				memo.push(moment(value).format("YYYY-MM-DD"));
				return memo;
			}, []);
			setUserDD(formattedDD);
		}
	}, [ddurl]);

	const computeDisabledDates = async () => {
		if (results !== "loading" && refunds !== "loading" && item !== "loading") {
			// console.log(DATA(refunds, results, item));
			setDates(DATA(results, refunds, item));
			let disabledDates = DisabledDates(item, dates, "DD");
			//console.log(disabledDates);
			//userDD.push(...disabledDates);
			//var sortedDD = _.sortBy(userDD, (v) => v);
			setDisabled(disabledDates);
		}
	};

	//<<< use effect >>>
	useEffect(() => {
		fetchItem();
		fetchPayment();
		fetchRefund();
		fetchUserDD();
	}, [fetchPayment, fetchRefund, fetchUserDD, fetchItem]);

	useEffect(() => {
		computeDisabledDates();
	}, [results, refunds, item, userDD, error, disabled.length]);

	// const onSubmit = (data) => {
	// 	console.log(data);
	// };

	if (error === "block") {
		return (
			<div style={{ display: error }}>
				<span>{results}</span>
				<span>{refunds}</span>
			</div>
		);
	} else if (
		typeof disabled === "object" &&
		typeof userDD === "object" &&
		typeof item === "object"
	) {
		const options = [
			{
				altInput: true,
				disable: [...disabled, ...userDD],
				minDate: moment().format("YYYY-MM-DD"),
				maxDate: moment().add(12, "M").format("YYYY-MM-DD"),
				defaultDate: moment().format("YYYY-MM-DD"),
				altFormat: "F j, Y",
				dateFormat: "Y-m-d"
			}
		];
		console.log(parseInt(item.ppd), parseInt(item.sell_p));
		return (
			<>
				<Fade>
					<div className="widget user text-center">
						<form action={`${env.pro.host}/home/item/${item.id}`} method="POST">
							{parseInt(item.ppd) !== 0 && parseInt(item.sell_p) !== 0 ? (
								<>
									<Picker
										options={options}
										item={item}
										dates={dates}
										disabled={disabled}
									/>
									<Times item={item} />{" "}
								</>
							) : (
								""
							)}
							{parseInt(item.sell_p) !== 0 && parseInt(item.ppd) === 0 ? (
								<>
									<Units
										item={item}
										start={moment().format("YYYY-MM-DD")}
										end={moment().format("YYYY-MM-DD")}
										dates={dates}
										disabled={disabled}
									/>
								</>
							) : (
								""
							)}
							{parseInt(item.sell_p) === 0 && parseInt(item.ppd) !== 0 ? (
								<>
									<>
										<Picker
											options={options}
											item={item}
											dates={dates}
											disabled={disabled}
										/>
										<Times item={item} />{" "}
									</>
								</>
							) : (
								""
							)}
							{parseInt(item.ppd) !== 0 ? <Button type="Rent" /> : ""}
							{parseInt(item.sell_p) !== 0 ? <Button type="Buy" /> : ""}
						</form>
					</div>
				</Fade>
			</>
		);
	} else {
		return <PlaceHolder />;
	}
};

export default DataAdapter;
